import React from 'react';

import { ModalContent } from 'shared/components/common/modal';

import Reservation from 'public/components/default_template/reservation/Reservation';

export const ReservationModalContent = () => {
  return (
    <ModalContent wrapperClassName="reservationModalWrapper" contentClassName="reservationModalContent" slideIn slideOut ariaLabelledBy={'reservation-modal-title'}>
      <div className="reservation">
        <Reservation isModal />
      </div>
    </ModalContent>
  );
};
